import React from 'react';
import { Flex } from 'antd';
import { formatDate } from 'shared/utils/time/format-date';
import { formatDateTime } from 'shared/utils/time/format-date-time';
import { CardUi } from 'components/common/card-ui';
import { ExpenseRelatedLinks } from 'components/expenses/expense-related-links';
import type { IExpenseInfoCardProps } from './types';

export const ExpenseInfoCard: React.FC<IExpenseInfoCardProps> = (props) => {
  const { expense } = props;

  return (
    <CardUi>
      <Flex align='start' gap='small' vertical>
        {expense.order || expense.trip || expense.warehouseTask ? (
          <div>
            <strong>Related:</strong>{' '}
            <ExpenseRelatedLinks order={expense.order} trip={expense.trip} warehouseTask={expense.warehouseTask} />
          </div>
        ) : null}
        <div>
          <strong>Created:</strong> {formatDateTime(expense.createdAt)}
        </div>
        {expense.completedDate ? (
          <div>
            <strong>Completed:</strong> {formatDate(expense.completedDate)}
          </div>
        ) : null}
      </Flex>
    </CardUi>
  );
};
